import { render, staticRenderFns } from "./ChangeHistoryLogs.vue?vue&type=template&id=00158be4&scoped=true&"
import script from "./ChangeHistoryLogs.vue?vue&type=script&lang=js&"
export * from "./ChangeHistoryLogs.vue?vue&type=script&lang=js&"
import style0 from "./ChangeHistoryLogs.vue?vue&type=style&index=0&id=00158be4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00158be4",
  null
  
)

export default component.exports